import BaseApiClient from "./base-client";
// API Class
class ParticipantsApi extends BaseApiClient {
    BASE_PATH = "/api/studies";
    getParticipants = (studyId, allowPending = false) => this.get(`${this.BASE_PATH}/${studyId}/participants`, {
        params: { allowPending }
    });
    static instance = new ParticipantsApi();
}
export default ParticipantsApi.instance;
